import { CurrencyOrEmpty } from '@plato/app-shared/components/currency-or-empty';
import { useCurrencyHelpers } from '@plato/app-shared/hooks/use-currency-helpers';
import { cn } from '@plato/ui/util/classes';
import { useTranslation } from 'react-i18next';

type MoneyDeltaBadgeProps = {
    children: number | undefined | null;
    className?: string;
    /**
     * Render a positive value as "up to <amount>" instead of "+<amount>": an opportunity's
     * potential is a ceiling, not a delta. Callers gate it on the insight bucket as well as
     * `AppConfig.enableUpToPotentialLabel`, so a risk card never gets it.
     */
    upToLabel?: boolean;
};

export function MoneyDeltaBadge({ children, className, upToLabel = false }: MoneyDeltaBadgeProps) {
    const { t } = useTranslation('insights');
    const { formatCurrency } = useCurrencyHelpers();
    const isPositive = children && children > 0 ? true : children && children < 0 ? false : null;

    return (
        <div
            className={cn(
                'flex shrink-0 flex-row items-center justify-center rounded-md',
                isPositive === true && 'text-green-600',
                isPositive === false && 'text-red-600',
                isPositive === null && 'text-neutral-600',
                className,
            )}
        >
            {upToLabel && isPositive === true ? (
                // Same formatter CurrencyOrEmpty uses, minus the plus sign the label replaces.
                t('money_badge__up_to', { amount: formatCurrency(children) })
            ) : (
                <CurrencyOrEmpty showPlusSignIfPositive>{children}</CurrencyOrEmpty>
            )}
        </div>
    );
}
